import { render, staticRenderFns } from "./form.vue?vue&type=template&id=2f6b3406&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6b3406')) {
      api.createRecord('2f6b3406', component.options)
    } else {
      api.reload('2f6b3406', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=2f6b3406&", function () {
      api.rerender('2f6b3406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/calendar/form.vue"
export default component.exports